import { RoomFilterChangeTypes } from "./room-filter-change-types.enum";
import { UnitType } from "./unit-type.model";
import { Selectable } from "../../shared/core/ovs.core";

export abstract class RoomFilterChangeInfo{
    public changeType: RoomFilterChangeTypes;
    constructor(){
        this.initialize();
    }
    public abstract initialize();
}

export class DateChangeInfo extends RoomFilterChangeInfo{
    public date: Date;
    public initialize(){
        this.changeType = RoomFilterChangeTypes.DateChange;
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/room-availability-v2/room-filter-change-info.model.ts